export default {
  translation: {
    welcome: 'Willkommen zu unserer Hochzeit!',
    rsvp: 'Zusage',
    enterToken: 'Bitte geben Sie Ihren Einladungscode ein',
    submit: 'Absenden',
    name: 'Name',
    attendingCeremony: 'Kommt zur Trauung?',
    attendingReception: 'Kommt zur Feier?',
    yes: 'Ja',
    no: 'Nein',
    primaryGuest: 'Ihre Details',
    dietaryRestrictions: 'Ernährungseinschränkungen',
    dietaryRestrictionsPlaceholder: 'Allergien und/oder Ernährungseinschränkungen auf...',
    menuChoice: 'Menüauswahl',
    menuStandard: 'Standard',
    menuVegetarian: 'Vegetarisch',
    menuVegan: 'Vegan',
    menuKids: 'Kindermenü',
    additionalGuests: 'Zusätzliche Gäste',
    guest: 'Gast',
    guestNamePlaceholder: 'Name des Gastes',
    ageGroup: 'Altersgruppe',
    adult: 'Nach Menü',
    child: 'Kinderbuffet',
    baby: 'Baby Hochstuhl',
    addGuest: 'Gast hinzufügen',
    removeGuest: 'Entfernen',
    message: 'Nachricht an das Paar',
    messagePlaceholder: 'Teil uns Eure Wünsche oder zusätzliche Informationen mit...',
    thankYou: 'Vielen Dank für Ihre Antwort!',
    error: 'Ein Fehler ist aufgetreten. Bitte versuch es erneut.',
    invalidToken: 'Ungültiges Token. Bitte überprüfen und erneut versuchen.',
    attendingGeneral: 'Wollt ihr an der Trauung teilnehmen?',
    attendingYes: 'Ja',
    attendingNo: 'Nein',
    pleaseSelect: 'Bitte wählen...',
    menuType: 'Menütyp',
    starter: 'Vorspeise',
    main: 'Hauptgericht',
    dessert: 'Nachspeise',
    restrictions: 'Ernährungseinschränkungen',
    submitSuccess: 'Ihre Zusage wurde übermittelt!',
    submitError: 'Beim Absenden ist ein Fehler aufgetreten. Bitte versuch es erneut.',

    // Wedding details
    weddingDetails: 'Hochzeitsdetails',
    ceremony: 'Trauung',
    ceremonyDate: '20. August 2025',
    ceremonyTime: '16:00 Uhr, Einlass ab 15:30 Uhr',
    ceremonyLocation: 'Old Marylebone Town Hall',
    ceremonyAddress: 'Westminster Council House, 97-113 Marylebone Rd, London NW1 5PT',
    ceremonyDescription: `Wir freuen uns, Euch zu unserer Trauungszeremonie in der Old Marylebone Town Hall einzuladen. Die Trauungszeremonie startet pünktlich um 16:00 Uhr im Westminster-Raum und wird in etwa 20 Minuten dauern.<1/>
    Gäste können ab 15:30 Uhr im Westminster-Raum eintreffen. Gepäck und Kinderwagen müssen in der Eingangshalle zurückgelassen werden.<1/>
     Anschließend werden wir ein Foto auf den Stufen der Old Marylebone Town Hall machen.`,
    ceremonyTransport:
      'Baker Street (Bakerloo, Circle, Hammersmith and City, Jubilee und Metropolitan lines). Unter anderem auch der 18er Bus.',

    reception: 'Empfang',
    receptionDate: '20. August 2025',
    receptionTime: '17:30 Uhr',
    receptionLocation: 'The William Pub',
    receptionAddress: '786 Harrow Road, Kensal Green, London NW10 5JX',
    receptionTransport: 'Kensal Green (Bakerloo Line), Kensal Green Cemetery (18er Bus)',
    receptionDescription:
      'Im Anschluss an die Zeremonie laden wir Euch Sie herzlich zum Abendessen und Tanz im The William Pub in Kensal Green ein, einem charmanten Veranstaltungsort, an dem wir bis in den Abend hinein feiern werden.',

    // FAQ section
    faqTitle: 'Häufig gestellte Fragen',
    loading: 'Wird geladen...',
    faqLoadError: 'FAQs konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
    noFaqsAvailable: 'Derzeit sind keine FAQs verfügbar.',
  },
};
